import React from 'react';
import firebase from "firebase/app";
import "firebase/analytics";
import './App.css';
import Home from './Component/Home/Home';
import NavContainer from './Component/NavContainer/NavContainer';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Skills from './Component/Skills/Skills';
import Projects from './Component/Projects/Projects';
import { FaWhatsapp } from 'react-icons/fa';
import Blogs from './Component/Blogs/Blogs';
import Contact from './Component/Contact/Contact';
import { firebaseConfig } from './Component/Contact/Firebase.Config';
import Footer from './Component/Footer/Footer';



firebase.initializeApp(firebaseConfig);
firebase.analytics();
firebase.analytics().logEvent('notification_received');
firebase.analytics().setUserProperties({language: 'english'});

function App() {
  return (
    <div className="App">
      <Router>
        <NavContainer></NavContainer>
        <Switch>
          <Route path='/home'>
            <Home></Home>
          </Route>
          <Route exact path='/'>
            <Home></Home>
          </Route>
          <Route path='/skills'>
            <Skills></Skills>
          </Route>
          <Route path='/projects'>
            <Projects></Projects>
          </Route>
          <Route path='/blogs'>
            <Blogs></Blogs>
          </Route>
          <Route path='/contact'>
            <Contact></Contact>
          </Route>
          <Route path="*">
            <h2 style={{ color: 'red' }}>Nothing Found! 404 Error...</h2>
            <h3>Return <Link to="/home">Home Page</Link></h3>
          </Route>
        </Switch>
        {/* whatsapp floating */}
        <div>
          <a href="https://wa.me/8801921652823" class="whatsapp_float" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp />
          </a>
        </div>
        
      </Router>

      <Footer></Footer>
    </div>
  );
}

export default App;
